import React from "react";
import UpdateStudent from "./create-form/CreateStudent";

const Profile = () => {
    return <UpdateStudent />;
};

export default Profile;
